import React, { useEffect } from 'react';
import { I } from '../lib/icons';

export default function ModalShell({ open, onClose, title, leftAction, rightAction, maxWidth = 640, children }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid="modal-backdrop"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(40,30,5,0.32)',
        backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
        animation: 'cd-fadeIn 0.18s var(--ease)',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
        style={{
          background: 'var(--bg-surface)', borderRadius: 'var(--r-2xl)',
          boxShadow: 'var(--sh-modal)',
          width: '100%', maxWidth, maxHeight: '92vh',
          display: 'flex', flexDirection: 'column',
          animation: 'cd-modalIn 0.24s var(--ease)',
          border: '1px solid var(--border)',
          overflow: 'hidden',
        }}
      >
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 18px', borderBottom: '1px solid var(--border)',
          flexShrink: 0,
        }}>
          <div style={{ minWidth: 88 }}>
            {leftAction || (
              <button onClick={onClose} style={{
                background: 'transparent', border: 'none', color: 'var(--text-muted)',
                display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, padding: 0, cursor: 'pointer', fontFamily: 'inherit',
              }}>
                <I.x /> Zavrieť
              </button>
            )}
          </div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{title}</div>
          <div style={{ minWidth: 88, display: 'flex', justifyContent: 'flex-end' }}>{rightAction}</div>
        </div>
        <div className="cd-scroll" style={{ overflowY: 'auto', flex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
